import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import routes, { PATH_ROUTE } from '../../routes';
import { hasAny, DASHBOARD } from 'utils/permissions';
import { permissionsSelector } from 'modules/Login/selectors/user';
import { useSelector } from 'react-redux';
import { portalAuthState } from "../../recoil/atoms/portalAuthState";
import { getRecoil } from "recoil-nexus";

const VerifyPermissionsAndLoggedUser = ({ component, children }) => {
    const sessionId = sessionStorage.getItem("@SMO20/idResponsavel");
    const sessionUsername = sessionStorage.getItem("@SMO20/nomeResponsavel");
    const permissions = useSelector(permissionsSelector);
    const isUserLoggedIn = (sessionId && sessionUsername) ? true : false;
    const hasRequiredPermissions = hasAny(permissions, [DASHBOARD]);
    // usuário admin não precisa de permissões
    const auth = getRecoil(portalAuthState);
    const token = auth?.token;

    const findRouteByPath = (path, routes) => {
        for (const route of routes) {
            if (route.path === path) return route;
            if (route.children) {
                const childRoute = findRouteByPath(path, route.children);
                if (childRoute) return childRoute;
            }
        }
        return null;
    }

    const currentRoute = findRouteByPath(window.location.pathname, routes);
    const routeRequiresPermissions = currentRoute && currentRoute.permissions;
    if (isUserLoggedIn || token || window.location.pathname === '/' || window.location.pathname.includes('returnTo') || window.location.pathname.includes('validar-carteirinha') || window.location.pathname === '/RedefinirSenha' || window.location.pathname === '/CriarSenha' || window.location.pathname === '/LoginExternal' || window.location.pathname === '/login/admin') {
        if (routeRequiresPermissions && hasRequiredPermissions) {
            return <Route component={component} render={() => children} />;
        } else if (routeRequiresPermissions && !hasRequiredPermissions) {
            return <Redirect to={PATH_ROUTE.CADASTRO_CONCLUIDO} />
        } else {
            return children;
        }
    } else {
        const queryParams = new URLSearchParams({ returnTo: window.location.pathname });
        const queryString = queryParams.toString();
        return (
            <Redirect to={isUserLoggedIn ? PATH_ROUTE.HOME_SMO : `/?${queryString}`} />
        );
    }
};

export default VerifyPermissionsAndLoggedUser;